export const rmNonDigitChars = number => `${number}`.replace(/\D/g, '')

export const formatTimestamp = (timestamp) => {
  if (!timestamp || !new Date(timestamp).toJSON()) return null

  const time = timestamp.split('T')
  return `${time[0]} ${time[1].substring(0, 5)} UTC`
}

const countryCodeTable = {
  AU: '61',
  IE: '353',
  IT: '39',
  US: '1',
  ZA: '27',
}

export const findPhoneCountryCode = cc => countryCodeTable[cc] || '1'

export const formatReminderNumber = (number, includeCountryCode = true) => {
  const justDigits = rmNonDigitChars(number)

  const formatWithSpans = (parts) => {
    const separatorStyle = 'margin-left: 2px; margin-right: 2px;'
    // Conditionally include the country code based on includeCountryCode
    const startIdx = includeCountryCode ? 0 : 1
    return parts.slice(startIdx).map((part, index) => `<span>${part}</span>${index < parts.length - 1 - startIdx ? `<span style="${separatorStyle}"></span>` : ''}`).join('')
  }

  const matchUS = justDigits.match(/^(1)(\d{3})(\d{3})(\d{4})$/)
  if (matchUS) {
    return formatWithSpans(matchUS.slice(1))
  }

  const matchAU = justDigits.match(/^(61)(\d{1})(\d{4})(\d{4})$/)
  if (matchAU) {
    return formatWithSpans(matchAU.slice(1))
  }

  const matchIT = justDigits.match(/^(39)(\d{2})(\d{3})(\d{4})$/)
  if (matchIT) {
    return formatWithSpans(matchIT.slice(1))
  }

  const matchIE = justDigits.match(/^(353)(\d{1})(\d{3})(\d{4})$/)
  if (matchIE) {
    return formatWithSpans(matchIE.slice(1))
  }

  const matchZA = justDigits.match(/^(27)(\d{2})(\d{3})(\d{4})$/)
  if (matchZA) {
    return formatWithSpans(matchZA.slice(1))
  }

  return number
}


// returns the same thing as formatReminderNumber without the country code
export const formatReminderNumWithoutCC = number => formatReminderNumber(number, false)

export const formatOfficeNumber = (number, countryCode) => {
  const justDigits = rmNonDigitChars(number)
  const areaCode = findPhoneCountryCode(countryCode)
  return areaCode ? justDigits.substring(areaCode.length) : number
}

export const formatPhoneNumberForUpdate = (number, countryCode) => {
  const justDigits = rmNonDigitChars(number)
  if (!justDigits) return null
  const phoneCountryCode = findPhoneCountryCode(countryCode)
  return `+${phoneCountryCode}${justDigits}`
}

export const sortValues = (a, b) => {
  switch (true) {
    case a < b:
      return -1
    case a > b:
      return 1
    default:
      return 0
  }
}

export const formatProductName = (name) => {
  switch (name) {
    case 'reminders':
      return 'R¹'
    case 'reminderstier2':
      return 'R²'
    case 'reviews':
      return 'Rᵛ'
    case 'topsremindersplus':
      return 'R⁺'
    case 'topsalertsplus':
      return 'A⁺'
    default:
      return name[0]
  }
}
export const formatFullProductName = (name) => {
  switch (name) {
    case 'dso':
      return 'DSO'
    case 'openchair':
      return 'OpenChair'
    case 'patientportal':
      return 'Patient Portal'
    case 'reminders':
      return 'Reminders Tier 1'
    case 'reminderstier2':
      return 'Reminders Tier 2'
    case 'reviews':
      return 'Reviews'
    case 'topsremindersplus':
      return 'Tops Reminders Plus'
    case 'topsalertsplus':
      return 'Tops Alerts Plus'
    case 'voip':
      return 'VoIP'
    case 'missedcalltext':
      return 'Missed Call Text'
    case 'crm':
      return 'CRM'
    case 'newapptmessages':
      return 'NAM'
    default:
      return name
  }
}



// WEBPACK FOOTER //
// ./src/services/utils.js